'use client';

import type { FC } from 'react';
import { Alert } from 'react-bootstrap';
import { TriangleAlert } from 'lucide-react';
import { MarkdownText } from '@/components/assistant-ui/markdown-text';
import { useAuiState } from '@assistant-ui/react';

/** Matches the Auto daily budget error from the chat API. */
export function isAutoBudgetExhaustedMessage(text: string): boolean {
  const normalized = text.replace(/\s+/g, ' ').trim();
  return /^بودجه[\u0654]?\s*روزانه[\u0654]?\s*Auto تمام شده است/.test(
    normalized
  );
}

/** Warning alert instead of a plain paragraph when the Auto daily budget is spent. */
export const McpAssistantText: FC = () => {
  const text = useAuiState(s =>
    s.part.type === 'text' && typeof s.part.text === 'string' ? s.part.text : ''
  );

  if (!isAutoBudgetExhaustedMessage(text)) return <MarkdownText />;

  return (
    <Alert
      variant="warning"
      className="mb-0 py-2 px-3 fs--1 d-flex align-items-start gap-2"
    >
      <TriangleAlert
        className="flex-shrink-0 mt-1"
        size={16}
        strokeWidth={2}
        aria-hidden
      />
      <span className="flex-grow-1">{text.trim()}</span>
    </Alert>
  );
};
